import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { get, put } from 'helpers/apiHelpers';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import {
  transformBrandData,
  transformModulesData,
} from './TransformDataToRequest';
import { getOtherBrand, postOtherBrand } from './AxiosFuncion';
import CopyingBrandSettingsView from './CopyingBrandSettings.view';

const CopyingBrandSettingsContainer = ({ sourceBrandInformation }) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loginData, setLoginData] = useState({
    apiAddress: '',
    email: '',
    password: '',
  });
  const [tokenFromLoginCheck, setTokenFromLoginCheck] = useState('');
  // brand data - list of brands and other information
  const [brandList, setBrandList] = useState([]);
  // selected brand - completely information with brand
  const [selectedBrandToCopy, setSelectedBrandToCopy] = useState({});

  const idSourceBrandInformation = sourceBrandInformation.id;

  const [sourceBrandModules, setSourceBrandModules] = useState({});

  useEffect(() => {
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    get(`brands/${idSourceBrandInformation}/modules`).then(res => {
      setSourceBrandModules(res.configuration);
    });
  }, [idSourceBrandInformation]);

  const handleChange = e => {
    setLoginData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleShowModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleLogin = () => {
    const postData = {
      url: `${loginData.apiAddress}/login_check`,
      username: loginData.email,
      password: loginData.password,
    };

    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    postOtherBrand(postData).then(response => {
      setTokenFromLoginCheck(response.data.token);

      const getData = {
        url: `${loginData.apiAddress}/brands`,
        token: response.data.token,
        brand: 1,
      };
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      getOtherBrand(getData).then(brandData => {
        setBrandList(brandData.data['hydra:member']);
      });
    });
  };

  const handleCopySettings = () => {
    const requestData = {
      url: `${loginData.apiAddress}/brands/${selectedBrandToCopy.id}/modules`,
      token: tokenFromLoginCheck,
      brand: selectedBrandToCopy.id,
    };
    const requestModulesData = transformBrandData(selectedBrandToCopy);
    put(`brands/${idSourceBrandInformation}`, requestModulesData)
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(() => {
        toast.success(t('brandCfg.copyingBrandSettings.brand.toast.success'));

        // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
        getOtherBrand(requestData).then(modulesData => {
          // eslint-disable-next-line no-shadow -- FIXME
          const requestModulesData = transformModulesData(
            modulesData.data.configuration,
            sourceBrandModules
          );
          put(`brands/${idSourceBrandInformation}/modules`, requestModulesData)
            // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
            .then(() => {
              setTimeout(() => {
                toast.success(
                  t('brandCfg.copyingBrandSettings.module.toast.success')
                );
              }, 3000);
            })
            // eslint-disable-next-line promise/prefer-await-to-then, promise/prefer-await-to-callbacks -- FIXME
            .catch(err => {
              toast.error(err);
            });
        });
      })
      // eslint-disable-next-line promise/prefer-await-to-then, promise/prefer-await-to-callbacks -- FIXME
      .catch(err => {
        toast.error(err);
      });
  };

  return (
    <CopyingBrandSettingsView
      loginData={loginData}
      setLoginData={setLoginData}
      handleChange={handleChange}
      handleLogin={handleLogin}
      brandList={brandList}
      sourceBrandInformation={sourceBrandInformation}
      selectedBrandToCopy={selectedBrandToCopy}
      setSelectedBrandToCopy={setSelectedBrandToCopy}
      handleCopySettings={handleCopySettings}
      isModalOpen={isModalOpen}
      handleShowModal={handleShowModal}
    />
  );
};

const mapStateToProps = state => ({
  sourceBrandInformation: state.Brands.brand,
});

const enhance = compose(connect(mapStateToProps));

export default enhance(CopyingBrandSettingsContainer);
